/** Returns against an invoice. */
export default {
  'returns.title': 'Returns',
  'returns.subtitle': 'Refund items against the original invoice',
  'returns.invoice': 'Invoice number',
  'returns.find': 'Find invoice',
  'returns.lookupFailed': 'Could not look up that invoice.',
  'returns.failed': 'Could not record the return.',
  'returns.recorded': 'Return {number} recorded',
  'returns.refundDue': 'Refund ₹{amount} to the customer.',
  'returns.debtReduced': 'Unpaid invoice balance reduced by ₹{amount}.',
  'returns.value': 'Return value ₹{amount} (includes ₹{tax} GST).',
  'returns.invalidQty': 'Enter a valid quantity with at most three decimal places.',
  'returns.bill': 'Bill ₹{amount}',
  'returns.item': 'Item',
  'returns.returnable': 'Returnable',
  'returns.qty': 'Return qty',
  'returns.paidFor': '₹{amount} for {qty} {unit}',
  'returns.fully': 'Fully returned',
  'returns.qtyFor': 'Return quantity for {name}',
  'returns.reason': 'Reason',
  'returns.reason.CustomerReturn': 'Customer changed mind',
  'returns.reason.WrongProduct': 'Wrong product',
  'returns.reason.BillingMistake': 'Billing mistake',
  'returns.reason.Damaged': 'Damaged (write off)',
  'returns.reason.Expired': 'Expired (write off)',
  'returns.reason.Other': 'Other',
  'returns.tooMany': 'A quantity is more than what can still be returned.',
  'returns.estimate': 'About ₹{amount} to refund',
  'returns.recording': 'Recording…',
  'returns.submit': 'Record return',
} as const;
